import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { motion, useTransform, useScroll } from "framer-motion";
import BlogAuthor from "../../components/BlogAuthor";
import { findConsultant } from "../../hooks/useConsultants";
import { findCampaignBlogByTitle } from "../../hooks/useCampaignBlogs";

export const BlogSubBanner = ({
  title,
  description,
  image,
  image2,
  customBannerColor,
  button,
  textBox,
  author,
  className,
  logoBanner = false,
}) => {

  // The Campaign Blogs author field links to the Consultants collection, so pull the
  // image, email and LinkedIn straight off the matched consultant. Fall back to the
  // blog's own record when the template doesn't map the author through as a prop.
  const blogAuthor = author || findCampaignBlogByTitle(title)?.author;
  const consultant = findConsultant(blogAuthor);

  const titleVariants = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.05 } },
  };

  return (
    <>
      <section className={`${styles.root} primary-banner mb-5 news-page ${className}`}>
        <Container>
          <div
            className={`content-wrapper rounded-3 shadow position-relative ${
              image2?.url
                ? "dualBannerImage py-lg-5 ps-lg-5  pt-4 ps-4 pb-4"
                : "overflow-hidden p-lg-5 p-4"
            }`}
            style={{ backgroundColor: customBannerColor }}
          >
            {image2 ? (
              <SourceFlowImage
                src={image2 || image2.url}
                size={`800x`}
                alt={image2.alt || "Banner Image"}
                className={`card-img rounded-0 banner-2 position-absolute ${
                  image2?.url
                    ? "rounded-3 shadow slideUp"
                    : "default-banner"
                }`}
                width="100%"
                height="100%"
              />
            ) : (
              ""
            )}
            {button.href && button.label ? (
              <Link href={button.href}>
                <a className="text-decoration-none primaryBtn-outline-white left-arrow rounded-5">
                    {button.label}
                </a>
              </Link>
            ) : (
              button.label ? (
                <span className="d-inline-block primaryBtn-outline-white no-arrow rounded-5 no-cursor">
                  {button.label}
                </span>
              ) : null
            )}

            <motion.h1
              initial="hidden"
              animate="visible"
              variants={titleVariants}
              className="post-title mt-4 mt-md-5 position-relative"
            >
              {title}
            </motion.h1>
            <div dangerouslySetInnerHTML={{ __html: description}} className="post-description mt-3 mt-md-4 position-relative" />

            {blogAuthor || consultant ? (
              <BlogAuthor
                author={blogAuthor}
                consultant={consultant}
                customClass={`on-dark mt-4 mt-md-5`}
              />
            ) : (
              ""
            )}
          </div>

          {textBox && (
            <div className="text-box position-relative" dangerouslySetInnerHTML={{ __html: textBox }} />
          )}
        </Container>
      </section>
    </>
  );
}

export default BlogSubBanner;
